import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { OAuthModule } from 'angular-oauth2-oidc';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PanelMenuModule } from 'primeng/panelmenu';
import { TreeModule } from 'primeng/tree';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ToolbarModule } from 'primeng/toolbar';
import { TabViewModule } from 'primeng/tabview';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ToastModule } from 'primeng/toast';
import { BlockUIModule } from 'primeng/blockui';
import { PanelModule } from 'primeng/panel';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ListboxModule } from 'primeng/listbox';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { SelectButtonModule } from 'primeng/selectbutton';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SidebarComponent } from './Pages/Sidebar/Sidebar'
import { IndicatorsListComponent } from './Pages/Indicators/List/IndicatorsList'
import { IndicatorEditComponent } from './Pages/Indicators/List/IndicatorEdit'
import { IndicatorCreateComponent } from './Pages/Indicators/List/IndicatorCreate'
import { FactorsListComponent } from './Pages/Indicators/List/FactorsList'
import { HandbooksListComponent } from './Pages/Handbooks/HandbooksList'
import { IndicatorsPeriodicityListComponent } from './Pages/Indicators/Periodicities/IndicatorsPeriodicityList'
import { IndustriesHandbookComponent } from './Pages/Handbooks/Industries/Industries';
import { CreateSphereComponent } from './Pages/Handbooks/Industries/CreateSphere'
import { HomeIndexComponent } from './Pages/Home/Index'
import { DateFormatPipe } from './Pipes/DateFormatPipe';
import { environment } from 'src/environments/environment';
import { TranslatePipe } from './Pipes/TranslatePipe';
import { CurrentLangPipe } from './Pipes/CurrentLangPipe';
import { IndicatorsPlannedListComponent } from './Pages/Indicators/Planned/IndicatorsPlannedList';
import { IndicatorsPublicListComponent } from './Pages/Indicators/Public/IndicatorsPublicList';
import { CookieService } from 'ngx-cookie-service';

@NgModule({
    declarations: [
        AppComponent,

        SidebarComponent,
        IndicatorsListComponent,
        IndicatorEditComponent,
        IndicatorCreateComponent,
        FactorsListComponent,
        IndicatorsPlannedListComponent,
        IndicatorsPublicListComponent,
        HandbooksListComponent,
        IndicatorsPeriodicityListComponent,
        IndustriesHandbookComponent,
        CreateSphereComponent,
        HomeIndexComponent,
        
        DateFormatPipe,
        TranslatePipe,
        CurrentLangPipe,
    ],
    entryComponents: [
        IndicatorEditComponent,
        IndicatorCreateComponent,
        FactorsListComponent,
        CreateSphereComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        OAuthModule.forRoot({
            resourceServer: {
                allowedUrls: [environment.apiUrl],
                sendAccessToken: true
            }
        }),

        ButtonModule,
        MenuModule,
        TieredMenuModule,
        TableModule,
        InputTextModule,
        PaginatorModule,
        DropdownModule,
        ProgressSpinnerModule,
        PanelMenuModule,
        TreeModule,
        MultiSelectModule,
        OverlayPanelModule,
        ScrollPanelModule,
        ToolbarModule,
        TabViewModule,
        DynamicDialogModule,
        KeyFilterModule,
        ToastModule,
        BlockUIModule,
        PanelModule,
        SplitButtonModule,
        TooltipModule,
        CalendarModule,
        InputSwitchModule,
        ListboxModule,
        MessagesModule,
        MessageModule,
        SelectButtonModule,

    ],
    providers: [ CookieService, CurrentLangPipe ],
    bootstrap: [ AppComponent ]
})
export class AppModule { }
